
export default {
  // Home page
  "airport_rankings": "Classificação de Aeroportos",
  "recent_reviews": "Avaliações Recentes",
  "loading_reviews": "Carregando avaliações...",
  "no_reviews": "Ainda não há avaliações.",
  "share_experience": "Compartilhe Sua Experiência",
  "help_photographers": "Ajude outros fotógrafos de filme compartilhando suas experiências em aeroportos",
  "add_review": "Adicionar Avaliação",
  "loading_leaderboard": "Carregando classificação...",
  "no_reviews_yet": "Ainda não há avaliações",
  "be_first": "Seja o primeiro a avaliar um aeroporto!",
  "best_airports": "Melhores Aeroportos",
  "worst_airports": "Piores Aeroportos",
  "success_rate": "Taxa de Sucesso",
  "airport_name": "Nome do Aeroporto",
  "airport_location": "Localização",
  "score": "Pontuação",
  "total_reviews": "Avaliações",
  "bottom_10_airports": "Os 10 piores aeroportos segundo fotógrafos de filme",
  "top_10_airports": "Os 10 melhores aeroportos segundo fotógrafos de filme",
  // Review tabs
  "all_reviews": "Todas as Avaliações",
  "verified_reviews": "Avaliações Verificadas",
  "no_verified_reviews": "Ainda não há avaliações verificadas.",
  "creative_reviews": "Avaliações de Criativos",
  "traveler_reviews": "Avaliações de Viajantes",
  "no_creative_reviews": "Ainda não há avaliações de criativos verificados.",
  "no_traveler_reviews": "Ainda não há avaliações de viajantes verificados."
};
